import { useState, useEffect } from "react";
import { Flame, Shuffle } from "lucide-react";
import { QUOTES } from "@/lib/vibesContent";

export default function MotivationCard() {
  const [, tick] = useState(0);
  const [offset, setOffset] = useState(0);
  useEffect(() => { const iv = setInterval(() => tick((t) => t + 1), 60000); return () => clearInterval(iv); }, []);
  const slot = Math.floor(Date.now() / 1800000);
  const quote = QUOTES[(slot + offset) % QUOTES.length];
  const minsLeft = 30 - (Math.floor(Date.now() / 60000) % 30);
  return (
    <div className="space-y-2 py-1">
      <Flame className="h-6 w-6 text-amber-500" />
      <p data-testid="motivation-quote" className="font-display text-base font-semibold leading-snug">
        "{quote.q}"
      </p>
      <p data-testid="motivation-author" className="font-hand text-lg opacity-70">— {quote.a}</p>
      <div className="flex items-center justify-between text-[10px] font-mono uppercase tracking-wider opacity-50">
        <span data-testid="motivation-countdown">next in {minsLeft}m</span>
        <button data-testid="motivation-shuffle" onClick={() => setOffset((o) => o + 1)}
          className="flex items-center gap-1 rounded-full px-2 py-0.5 transition-colors hover:bg-black/10">
          <Shuffle className="h-3 w-3" /> another
        </button>
      </div>
    </div>
  );
}
